import Module1 from 'src/assets/images/icBrandAppleSolid.svg';
import Module2 from 'src/assets/images/icBrandGooglePlaySolid.svg';
import Module3 from 'src/assets/images/icBrandInstagramSolid.svg';
import Module4 from 'src/assets/images/icBrandFacebookSolid.svg';
import Module5 from 'src/assets/images/icBrandYoutubeSolid.svg';
const appConfig={
  "serviceCode": "azar",
  "supportedLanguages": [
    "ar",
    "az",
    "de",
    "en",
    "es",
    "es-AR",
    "fr",
    "id",
    "it",
    "ja",
    "ko",
    "nl",
    "pt",
    "pt-BR",
    "sv",
    "th",
    "tr",
    "vi",
    "zh-CN",
    "zh-TW"
  ],
  "defaultLanguage": "en",
  "appDownloadLinks": [
    {
      "url": "https://azarlive.onelink.me/fHTc/sp41rwbq",
      "i18nKey": "BUTTON__APP_STORE",
      "type": "appstore",
      "icon": Module1
    },
    {
      "url": "https://azarlive.onelink.me/fHTc/sp41rwbq",
      "i18nKey": "BUTTON__GOOGLE_PLAY",
      "type": "playstore",
      "icon": Module2
    }
  ],
  "socialLinks": [
    {
      "key": "instagram",
      "url": "https://www.instagram.com/azar_official/",
      "icon": Module3
    },
    {
      "key": "facebook",
      "url": "https://www.facebook.com/azar.app.kr/?brand_redir=451242528327268",
      "icon": Module4
    },
    {
      "key": "youtube",
      "url": "https://www.youtube.com/c/OfficialAzar/videos",
      "icon": Module5
    }
  ],
  "layout": {
    "header": {
      "type": "APP_LIKE"
    },
    "showLoginModalOnPrivateRoute": false
  },
  "availableLoginMethods": [
    "google",
    "facebook",
    "phone",
    "apple"
  ],
  "features": {
    "followPage": {
      "enabled": true
    },
    "dm": {
      "enabled": true
    },
    "blog": {
      "enabled": false
    },
    "vip": {
      "enabled": true
    },
    "history": {
      "entry": "ROUTE"
    },
    "itemInventory": {
      "enabled": true
    },
    "profilePreferredLanguage": {
      "enabled": true
    },
    "userProfile": {
      "enabled": true
    }
  },
  "headers": {
    "x-azar-api-version": 9999
  },
  "helpCenterBaseUrl": "https://help.azarlive.com",
  "helpCenterApiUrl": "https://hpcnt.zendesk.com/api/v2/help_center",
  "helpCenterSectionIds": {
    "termsOfService": 32227730890137,
    "privacyPolicy": 32227849672729,
    "locationBasedTerms": 55946316043289,
    "cookiePolicy": 55542588821529
  },
  "helpCenterArticleUrls": {
    "communityGuidelines": "https://help.azarlive.com/hc/articles/360047526053"
  },
  "webToAppModalConfig": {
    "url": "https://azarlive.onelink.me/fHTc?af_xp=custom&pid=web_to_app&is_retargeting=true&af_reengagement_window=30d",
    "shouldInjectCampaignId": true
  },
  "gtmId": "GTM-WQT6PKJ",
  "appsflyerWebDevKey": "e1b27d6b-2273-4677-9b2d-937c07a360b0"
};export default appConfig;